import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor, errorInterceptor, loadingInterceptor, responseInterceptor } from './core/interceptors';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

import { routes } from './app.routes';

// Custom theme with Pharmigo brand colors
const PharmigoPrimeTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e6f7f6',
      100: '#b3e8e4',
      200: '#80d9d2',
      300: '#4dcac0',
      400: '#26beb2',
      500: '#03a297',
      600: '#029387',
      700: '#027a70',
      800: '#016159',
      900: '#014842',
      950: '#002f2b'
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    MessageService,
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor, responseInterceptor, errorInterceptor])),
    providePrimeNG({
      theme: {
        preset: PharmigoPrimeTheme,
        options: {
          darkModeSelector: '.dark-mode'
        }
      }
    })
  ]
};
